<div id="confirm-dialog">
  <div class="header">
    <i class="pi pi-exclamation-circle icon"></i>
    <h4>Warning:</h4>
  </div>

  <div class="body">
    <div class="text">{{ message }}</div>
    <div class="buttons">
      <p-button (click)="close()" label="Ok"></p-button>
    </div>
  </div>

</div>
